<template>
  <section id="modal-files-service">
    <loading-flux :value="loading"></loading-flux>
    <v-dialog v-model="modalAction" width="1300px" scrollable persistent>
      <v-card>
        <div class="p-4 pb-0" v-if="currentService">
          <h5>
            Documentos del Servicio: <b>{{ currentService.name }}</b>
          </h5>
        </div>
        <hr />
        <v-card-text>
          <v-container class="">
            <v-tabs v-if="currentService" v-model="tabsFiles" fixed-tabs>
              <v-tabs-slider></v-tabs-slider>
              <v-tab class="" value="quotes">
                Cotizaciones
              </v-tab>
              <v-tab value="other">
                Otros Documentos
              </v-tab>
              <v-tab @click="generateOcPDF(false)" value="oc" v-if="currentRequestIsApproved && (currentRequestIsApprovedOc || REQUEST_SERVICE_CONSTANTS.ifServiceHasOC(currentService))">
                OC
              </v-tab>
            </v-tabs>
            <section v-if="currentService" class="mt-3">
              <section class="quotes-attached" v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes && typeRequestService !== REQUEST_SERVICE_MAVERICK">
                <div class="d-flex justify-content-start align-items-start mt-5" v-if="actionToUploadFiles">
                  <v-btn class="mt-5 float-right" color="primary" outlined small @click="openModalTableAddQuote">
                    Agregar Cotización Existente
                    <v-icon class="ml-2" small> mdi-file-plus </v-icon>
                  </v-btn>
                  <v-btn class="mt-5 float-right text-white mx-3" color="red darken-2" small @click="dettachQuotationToService" v-if="(currentService && currentService.quotation_attached) && actionToUploadFiles">
                    Desvincular Cotización
                    <v-icon class="ml-2" small> mdi-cancel </v-icon>
                  </v-btn>
                </div>
                <p class="text-info mt-4" v-if="(currentService && currentService.quotation_attached) && actionToUploadFiles">
                  <v-icon color="blue lighten-2" class="mr-1"> mdi-information-outline </v-icon>
                  <b>ATENCIÓN:</b> Al seleccionar una cotización existente, no se podrán modificar los documentos ni el valor de <b>Exento de IVA</b> de la misma.
                </p>
                <h6 v-if="(currentService && currentService.quotation_attached)" class="mt-12 mx-3 text-primary">
                  Cotización vinculada: <b>{{ currentService.quotation_attached.shopping_index }}</b>
                </h6>
              </section>
              <v-simple-table class="my-10" v-if="!loadingGeneratingOc && documentFilesFromCategory.length" :key="keyDocumentsTable">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" v-if="documentFilesFromCategory.length > 1 && tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        Cotización Seleccionada
                      </th>
                      <th class="text-left">Nombre</th>
                      <th class="text-left" v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes && !userCreateRequestService">
                        Tasa de Cambio Utilizada
                      </th>
                      <th class="text-left" v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes && userCreateRequestService">
                        Tipo de Cambio
                      </th>
                      <th class="text-left" v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        Precio Neto
                      </th>
                      <th class="text-left" v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        Precio Neto en Pesos
                      </th>
                      <th class="text-center" v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        Proveedor
                      </th>
                      <th class="text-center">Acción</th>
                      <th class="text-center" v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        Proveedor Único
                      </th>
                      <th class="text-center" v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        Proveedor Único con Contrato
                      </th>
                      <th class="text-left" v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        Exento de IVA
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="document in documentFilesFromCategory" :key="document.id">
                      <!-- Columna de Selección -->
                      <td v-if="documentFilesFromCategory.length > 1 && tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        <div class="d-flex justify-content-center">
                          <v-checkbox :disabled="(!userCreateRequestService && !requestingUserModule) || currentRequestStatusIsPendingApproval || currentRequestStatusIsPurchaseValidationVariant || currentRequestStatusIsPurchaseValidation"
                            :input-value="document.selected" @change="selectDocument(document)">
                          </v-checkbox>
                        </div>
                      </td>
                      <!-- Columna de Nombre de Archivo -->
                      <td>
                        <a v-if="!userCreateRequestService || document.quotation_id"
                          @click.prevent="currentService.created_oc && currentService.created_oc.length && document.document_type == REQUEST_SERVICE_CONSTANTS.document_category_oc_text ? downloadFileWithNewname(document, `${currentService.created_oc[0]} - ${currentRequest.sale_order}.pdf`) : downloadFile(document)"
                          class="text-primary">
                          <div class="d-flex align-items-center my-1">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" color="primary" v-if="document.quotation_id">
                                  mdi-file-account-outline
                                </v-icon>
                              </template>
                              <span v-if="document.quotation_id">Documento vinculado a la cotización {{ currentService.quotation_attached.shopping_index }}</span>
                            </v-tooltip>
                            <v-icon color="red" class="ml-1 mr-2"> mdi-file-pdf </v-icon>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <p v-bind="attrs" v-on="on" class="my-2">
                                  {{ currentService.created_oc && currentService.created_oc.length && document.document_type == REQUEST_SERVICE_CONSTANTS.document_category_oc_text
                                    ? `${currentService.created_oc[0]} - ${currentRequest.sale_order}.pdf`
                                    : document.document_name }}
                                </p>
                              </template>
                              <span>Descargar archivo</span>
                            </v-tooltip>
                          </div>
                        </a>
                        <div v-else class="d-flex align-items-center justify-content-start">
                          <v-icon color="red" class="mr-2"> mdi-file-pdf </v-icon>
                          <p class="my-2 font-weight-bold">{{ document.file.name }}</p>
                        </div>
                      </td>
                      <!-- Columna de Tipo de Cambio -->
                      <td v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        <p class="my-0 mt-1" style="font-size: 12px">
                          {{ document.coin == REQUEST_SERVICE_CONSTANTS.coin_types[0].value ? '---' : document.exchange_rate }}
                        </p>
                      </td>
                      <!-- Columna de Precio -->
                      <td v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        <section class="text-left d-flex align-items-center" v-if="userCreateRequestService || currentDocumentEdit == document.id">
                          <v-select :disabled="document.quotation_id != null" @change="userCreateRequestService ? sendUpdateExchangeRates(document) : formatIsCurrencyClp(document)"
                            v-model="document.coin" :items="REQUEST_SERVICE_CONSTANTS.coin_types" item-text="text" item-value="value"
                            style="max-width: 60px" class="font-size-12 mr-3 mb-1" />
                          <small class="mr-1">{{ REQUEST_SERVICE_CONSTANTS.getCurrencySymbol(document.coin) }}</small>
                          <input v-if="userCreateRequestService" class="form-control-quantity" type="text" :disabled="document.quotation_id != null"
                            v-model="document.price" @blur="sendUpdateExchangeRates(document)" @input="formatPrice(document, $event)" hide-details />
                          <input v-else class="form-control-quantity" type="text" v-model="currentDocumentPrice"
                            @input="formatCurrentDocumentPrice(document, $event)" hide-details :disabled="document.quotation_id != null" />
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn @click="updatePriceQuotation(document)" v-if="currentDocumentEdit == document.id"
                                v-on="on" v-bind="attrs" icon :disabled="loadingDocument" x-small class="pointer mx-1">
                                <v-icon color="primary"> mdi-send </v-icon>
                              </v-btn>
                            </template>
                            <span>Confirmar modificación de precio</span>
                          </v-tooltip>
                        </section>
                        <p v-else class="my-0 mt-1" style="font-size: 12px">
                          <section class="d-flex align-items-center">
                            {{ `${document.price ? document.price.toLocaleString('en-US', { maximumFractionDigits: 2 }).replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, ',') : 0} ${document.coin ? document.coin : "CLP"}` }}
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="setCurrentDocumentEdit(document)"
                                  v-if="activeEditPriceAndSupplierFiles && currentDocumentEdit != document.id && !document.quotation_id"
                                  v-bind="attrs" icon :disabled="loadingDocument" x-small color="red" class="pointer mx-1" v-on="on">
                                  <v-icon color="orange"> mdi-pencil </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ document.price ? "Modificar precio" : "Cotizar Precio" }}</span>
                            </v-tooltip>
                          </section>
                        </p>
                      </td>
                      <!-- Columna de Monto -->
                      <td v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        <p v-if="document.coin == REQUEST_SERVICE_CONSTANTS.coin_types[0].value || currentDocumentEdit == document.id" class="my-0 mt-1" style="font-size: 12px">
                          ---
                        </p>
                        <p v-else class="my-0 mt-1" style="font-size: 12px">{{ document.amount ? document.amount : "-" }} CLP</p>
                      </td>
                      <!-- Columna de Proveedor -->
                      <td v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        <span v-if="document.supplier_name || document.supplier_rut || document.supplier" class="d-flex align-items-center">
                          {{ document.supplier_name ? document.supplier_name : document.supplier_rut ? document.supplier_rut : document.supplier }}
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-if="showAlertInvalidSupplier(document)" color="red darken-3" class="mx-3" v-bind="attrs" v-on="on">
                                mdi-account-alert
                              </v-icon>
                            </template>
                            <span>Esta Cotización tiene un Proveedor Cargado por el <span :class="{ 'text-white bg-primary rounded px-1': document.supplier_email == supplier_uploaded_by_purchase_user, 'text-white bg-danger rounded px-1': document.supplier_email == supplier_uploaded_by_user }">
                                {{ document.supplier_email == supplier_uploaded_by_purchase_user ? 'Equipo de Compras' : 'Solicitante' }}
                              </span> que no existe en SAP ni en Formulario de Proveedores</span>
                          </v-tooltip>
                          <!-- Flujo bloqueado: creación directa de proveedor deshabilitada en SOC -->
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn @click="showSupplierCreationRequestAlert()" v-if="!document.quotation_id && showAlertInvalidSupplier(document) && requestingUserModule && currentRequestStatusIsUserValidationVariant && document.supplier_email == supplier_uploaded_by_user && documentFilesFromCategory.length == 1 && tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes"
                                v-on="on" v-bind="attrs" icon x-small :disabled="loadingDocument" color="red" class="pointer">
                                <v-icon color="orange"> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Crear proveedor desde módulo de Solicitudes</span>
                          </v-tooltip>
                          <!-- Modificar proveedor normal -->
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn @click="openModalSearchSupplier(document)" v-if="activeEditPriceAndSupplierFiles && !document.quotation_id"
                                v-on="on" v-bind="attrs" icon x-small :disabled="loadingDocument" color="red" class="pointer">
                                <v-icon color="orange"> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Modificar Proveedor</span>
                          </v-tooltip>
                        </span>
                        <v-btn v-else-if="userCreateRequestService || (uploadFiles && activeEditPriceAndSupplierFiles)" small color="primary" :disabled="loadingDocument" @click="openModalSearchSupplier(document)">
                          <v-icon small class="mr-1" color="white"> mdi-account-plus </v-icon>
                          <span class="mt-px">Agregar Proveedor</span>
                        </v-btn>
                        <span v-else>-</span>
                      </td>
                      <td>
                        <v-btn :disabled="document.quotation_id != null && document.quotation_id !== undefined"
                          v-if="(userCreateRequestService || activeManagmetFiles || (currentRequestIsApproved && !requestingUserModule)) && permissionToDeleteFile(document)"
                          icon color="red darken-2" small @click="userCreateRequestService ? deleteFile(document) : deleteUploadFile(document)">
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </td>
                      <!-- Columna de Proveedor Único -->
                      <td v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        <div class="d-flex justify-content-center">
                          <v-checkbox :disabled="(!userCreateRequestService && !requestingUserModule) || currentRequestStatusIsPendingApproval || currentRequestStatusIsPurchaseValidationVariant || currentRequestStatusIsPurchaseValidation"
                            :input-value="document.unique_supplier" @change="(value) => changeUniqueSupplierDocument(document, value)">
                          </v-checkbox>
                        </div>
                      </td>
                      <!-- Columna de Proveedor con Contrato -->
                      <td v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        <div class="d-flex justify-content-center">
                          <v-checkbox :disabled="(!userCreateRequestService && !requestingUserModule) || currentRequestStatusIsPendingApproval || currentRequestStatusIsPurchaseValidationVariant || currentRequestStatusIsPurchaseValidation"
                            :input-value="document.unique_supplier_with_contract" @change="(value) => changeContractStatusDocument(document, value)">
                          </v-checkbox>
                        </div>
                      </td>
                      <!-- Columna de Exento de IVA -->
                      <td v-if="tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_quotes">
                        <div class="d-flex justify-content-center">
                          <v-checkbox :disabled="document.quotation_id === null || (!userCreateRequestService && !requestingUserModule) || currentRequestStatusIsPendingApproval || currentRequestStatusIsPurchaseValidationVariant || currentRequestStatusIsPurchaseValidation"
                            :input-value="document.tax_exempt" @change="changeTaxExemptDocument(document)">
                          </v-checkbox>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <div v-else-if="loadingGeneratingOc" class="text-center my-5 pt-5">
                <v-progress-circular class="mx-2" indeterminate color="primary"></v-progress-circular>
                <span>Cargando OC..</span>
              </div>
              <p class="text-center my-5 pt-5" v-else>Sin Archivos Cargados</p>
              <section class="d-flex align-items-center justify-content-center" v-if="loadingDocument">
                <v-progress-circular class="mx-2" indeterminate color="primary"></v-progress-circular>
                <span>Actualizando Documento</span>
              </section>
            </section>
            <section class="mx-2" v-if="filesRequired.length && !userCreateRequestService && !currentRequestStatusIsRejected && !loadingGeneratingOc">
              <h5>Documentos Necesarios</h5>
              <ul class="mt-3 px-0">
                <li class="d-flex align-items-center my-1" v-for="file in filesRequired" :key="file.id">
                  <span class="text-left font-weight-bold">{{ file.name }}</span>
                  <span class="ml-2">-</span>
                  <span class="mx-2" :class="{ 'text-success': file.status, 'text-danger': !file.status }">
                    Tienes {{ file.count }} {{ file.count > 1 || file.count == 0 ? 'Archivos' : 'Archivo' }}
                  </span>
                  <span style="font-size: 1.1rem">{{ file.status ? '✅' : '❌' }}</span>
                </li>
              </ul>
            </section>
            <section class="mt-8" v-if="actionToUploadFiles && !loadingGeneratingOc">
              <v-file-input accept="application/pdf" multiple counter show-size chips deletable-chips
                placeholder="Puedes Cargar Aquí los Documentos del Servicio" :value="form.files" @change="updateFiles" @click:clear="form.files = []">
              </v-file-input>
              <v-btn class="mt-5 float-right" color="primary" shaped small :disabled="!form.files.length"
                @click="userCreateRequestService ? updateFilesService() : updateFilesUploadService()">
                Cargar Archivos
                <v-icon class="ml-2" small> mdi-send </v-icon>
              </v-btn>
            </section>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" outlined @click="executeModalFilesService">
            <small>Cerrar</small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <table-add-supplier ref="tableAddSupplier" :modalAction="dialogAddSupplier"
      :closeModalTableAddSupplier="closeModalTableAddSupplier" :currentDocument="currentDocument" :requestOc="true"
      @addSupplierSelected="addSupplierSelected" @openModalCreateSupplier="showSupplierCreationRequestAlert"
      @openModalSetOnlyRutSupplier="openModalSetOnlyRutSupplier" :typeRequestService="typeRequestService">
    </table-add-supplier>
    <search-supplier ref="searchSupplier" :modalAction="dialogSearchSupplier"
      :closeModalSearchSupplier="closeModalSearchSupplier" :onlyRut="onlyRut" @emitSearch="openModalAddSupplier"
      @addSupplier="addSupplierSelected">
    </search-supplier>
    <modal-create-supplier :modalAction="dialogCreateSupplier" :closeModalCreateSupplier="closeModalCreateSupplier"
      :showOnlyCompleteSupplier="true" @emitNameSupplier="addSupplierSelected" @resetDocumentsSelected="resetDocumentsSelected">
    </modal-create-supplier>
    <table-add-quotes-for-oc v-if="uploadFiles" :modalAction="dialogTableAddQuotes"
      :closeModalTableAddQuote="closeModalTableAddQuote" :currentService="currentService"
      @addQuoteSelected="onAddQuoteSelectedToService">
    </table-add-quotes-for-oc>
  </section>
</template>

<script>
  import { mapActions } from "vuex";
  import swal2 from "sweetalert2";
import {
  preventCloseIfNotKeyEventEsc,
  renameAndReturnNewFile,
} from "@/helpers/common";
import REQUEST_SERVICE_CONSTANTS from "@/constants/requestService";
import { REQUEST_SERVICE_MAVERICK, REQUEST_SERVICE_UNIQUE_SUPPLIER } from "@/constants/requestMaterial";
import { authUsuarioComputed } from "@/state/helpers";
import TableAddSupplier from './TableAddSupplier.vue';
import SearchSupplier from '@/components/commons/SearchSupplier.vue';
import ModalCreateSupplier from '../../supplying/formSuppliers/components/ModalCreateSupplier.vue';
import exchangeRateMixin from "@/mixins/exchangeRate";
import TableAddQuotesForOc from './quotes/TableAddQuotesForOc.vue';
import { generateRandomCode } from "@/helpers/common";

export default {
  mixins: [exchangeRateMixin],
  components: { TableAddSupplier, SearchSupplier, ModalCreateSupplier, TableAddQuotesForOc },
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalFilesService: {
      type: Function,
      default: () => {},
    },
    currentService: {
      default: null,
    },
    requestId: {
      default: null,
    },
    currentRequest: {
      default: null,
    },
    requestingUserModule: {
      type: Boolean,
      default: false,
    },
    uploadFiles: {
      type: Boolean,
      default: true,
    },
    typeRequestService: {
      default: null,
    },
    userCreateRequestService: {
      type: Boolean,
      default: true
    },
    requestQuote: {
      type: Boolean,
      default: false,
    },
    requestPurchaseOrder: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      keyDocumentsTable: new Date().getTime(),
      loading: false,
      loadingDocument: false,
      loadingGeneratingOc: false,
      tabsFiles: "quotes",
      REQUEST_SERVICE_CONSTANTS,
      REQUEST_SERVICE_MAVERICK,
      REQUEST_SERVICE_UNIQUE_SUPPLIER,
      form: {
        files: [],
      },
      // Add Supplier
      onlyRut: false,
      dialogAddSupplier: false,
      dialogCreateSupplier: false,
      dialogSearchSupplier: false,
      dialogTableAddQuotes: false,
      currentDocument: null,
      isUpdatingUniqueSupplier: false,

      // Edit Document
      currentDocumentEdit: null,
      currentDocumentPrice: null,

      //Supplier Email Validation
      supplier_uploaded_by_purchase_user: REQUEST_SERVICE_CONSTANTS.supplier_uploaded_by_purchase_user,
      supplier_uploaded_by_user: REQUEST_SERVICE_CONSTANTS.supplier_uploaded_by_user,
    };
  },
  methods: {
    ...mapActions({
      sendDeleteFile: "requestService/deleteFileService",
      sendUpdateFilesService: "requestService/updateService",
      sendUpdateService: "requestService/updateService",
      changeSingleSupplierLetterFile: "requestService/changeSingleSupplierLetterFile",
      getDataOcFromSoc: "requestService/getDataOcFromSoc",
    }),

    
    async updateContractStatusDocument(document, value) {
      let self = this;
      
      if(this.userCreateRequestService){
        this.currentService.documents.forEach((file) => {
          if (file.id == document.id) {
            file.has_contract = value;
            file.unique_supplier_with_contract = value;
            
            // Si se marca como "Proveedor Único con Contrato", se desmarca "Proveedor Único" para ese documento.
            if(value === true){
              file.unique_supplier = false;
            }
          }
        });
        // No forzamos re-render completo de la tabla;
        // Vue reactivo actualiza el checkbox con los cambios anteriores.
      } else {
        if(document.quotation_id){
          document.has_contract = value;
          document.unique_supplier_with_contract = value;

          let payloadToUpdateService = {
            [document.quotation_id]: {
              action: 'update',
              selected: this.currentService.documents.filter(item => item.quotation_id && item.selected).map(item => item.id),
              unique_supplier: this.currentService.documents.filter(item => item.quotation_id && item.unique_supplier && !item.unique_supplier_with_contract && !item.has_contract).map(item => item.id),
              has_contract: value ? [document.id] : [],
              unique_supplier_with_contract: value ? [document.id] : [],
              tax_exempt: this.currentService.documents.filter(item => item.quotation_id && item.tax_exempt).map(item => item.id)
            },
          };
          return await this.updateService({}, payloadToUpdateService);
        } else {
          await this.updateService({
            [document.document_name]: {
              action: 'update',
              comment: value ? "Marcado como Proveedor Único con Contrato" : "Desmarcado como Proveedor Único con Contrato",
              selected: document.selected,
              supplier: document.supplier,
              type: document.document_type,
              unit_price: document.price,
              coin: document.coin ? document.coin : "CLP",
              unique_supplier: document.unique_supplier,
              unique_supplier_with_contract: value,
              has_contract: value,
              tax_exempt: document.tax_exempt
            }
          });
          // Igual que arriba, evitamos forzar destrucción/recreación de la tabla.
        }
      }
    },
    async downloadFile(documentFile, openFile = false) {
      const response = await fetch(documentFile.document_path.replace(/%/g, "%25"), {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
          "Content-Disposition": "inline"
        }
      });
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = documentFile.document_name;
      if(openFile){
        try {
          window.open(`https://docs.google.com/gview?url=${documentFile.document_path}`, "_blank");

        } catch (error) {
          console.log(error)
        }
        return
      }
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    },
    async downloadFileWithNewname(documentFile, newName) {
      const response = await fetch(documentFile.document_path.replace(/%/g, "%25"), {
        method: "GET",
      });
      const blob = await response.blob();
      let fileWitnewName =  new File([blob], newName, { type: blob.type });
      const downloadUrl = window.URL.createObjectURL(
        fileWitnewName
      );
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = newName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    },  
    alertPriceBidding(document){
      let priceDocument = document.coin !== REQUEST_SERVICE_CONSTANTS.coin_types[0].value ? document.amount ? document.amount : 0 : document.price ? document.price : 0;
      if(priceDocument && priceDocument.replaceAll('.', '') >= REQUEST_SERVICE_CONSTANTS.service_amount_to_request_bidding){
        return this.$swal.fire({
          icon: "info",
          title: "Atención",
          text: `Ten en cuenta que los servicios con precios igual o mayores a $${this.formatCurrency(REQUEST_SERVICE_CONSTANTS.service_amount_to_request_bidding)} CLP, deben pasar por un proceso de licitación para ser aprobados.`,
          showConfirmButton: true,
          confirmButtonColor: "#1076D0",
          confirmButtonText: `Aceptar`,
        });
      }
    },
    async sendUpdateExchangeRates(item, emitUpdate = true) {
      if(item.coin && item.coin !== REQUEST_SERVICE_CONSTANTS.coin_types[0].value && item.price){
        const itemExchangeRate = await this.mapExchangeRate([item]);
        this.alertPriceBidding(itemExchangeRate[0])
        if(!emitUpdate) return itemExchangeRate;
        this.$emit('updateExchangeRateCurrentService', itemExchangeRate[0]);
      }else if(item.price){
        item.price = this.formatCurrency(String(item.price).replaceAll(/,/g, ''));
        this.alertPriceBidding({...item, price: String(item.price)})
      }
    },
    formatIsCurrencyClp(document){
      if(document.coin === REQUEST_SERVICE_CONSTANTS.coin_types[0].value){
        this.currentDocumentPrice = this.formatCurrency(String(document.price).split('.')[0]);
      }
    },
    resetDocumentsSelected(){
      if(this.userCreateRequestService && this.currentService.documents.length > 1){
        if(this.isUpdatingUniqueSupplier){
          this.currentService.documents.forEach(document => {
            document.unique_supplier = false;
          });
        }else {
          this.currentService.documents.forEach(document => {
            document.selected = false;
          });
        }
        this.isUpdatingUniqueSupplier = false
        this.keyDocumentsTable++
      }else if (!this.userCreateRequestService) {
        if(this.isUpdatingUniqueSupplier){
          this.currentDocument.unique_supplier = true
          this.updateUniqueSupplierDocument(this.currentDocument, false)
        }else {
          this.currentDocument.selected = true
          this.selectDocument(this.currentDocument)
        }
        this.isUpdatingUniqueSupplier = false
      }
    },
    showAlertInvalidSupplier(document) {
      return (
        (this.typeRequestService !== REQUEST_SERVICE_MAVERICK && this.typeRequestService !== REQUEST_SERVICE_UNIQUE_SUPPLIER) &&
        REQUEST_SERVICE_CONSTANTS.ifDocumentHasQuotesWithInvalidSupplier(
          document
        ) &&
        (this.currentRequestStatusIsUserValidationVariant ||
          this.currentRequestStatusIsPurchaseValidationVariant)
      );
    },
    async showSupplierCreationRequestAlert() {
      return this.$swal.fire({
        icon: "error",
        title: "Proveedor no válido",
        html: "Por favor crear el proveedor en el modulo correspondiente : Solicitudes > Solicitar creacion de proveedor",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#1076D0",
      });
    },
    setCurrentDocVacurrentRequestStatusIsPurchaseValidation(document) {
      this.currentDocumentEdit = document.id;
      this.currentDocumentPrice = document.price ? document.price.toLocaleString('en-US', { maximumFractionDigits: 2 }).replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, ',') : 0;
    },

    // ==================== MÉTODO MODIFICADO PARA PROVEEDOR ÚNICO (CONDICIONAL) ====================
    async updateUniqueSupplierDocument(document, value, type = 'UniqueSupplier') {
      const isOnlyOneQuote = this.documentFilesFromCategory.length === 1;

      // Si se intenta marcar como verdadero y el proveedor es inválido
      if (value === true && !document.valid_supplier && this.typeRequestService !== REQUEST_SERVICE_MAVERICK) {
        if (isOnlyOneQuote) {
          await this.showSupplierCreationRequestAlert();
          return;
        } else {
          await this.showSupplierCreationRequestAlert();
          return; 
        }
      }

    
      if(this.userCreateRequestService){
          this.currentService.documents.forEach((file) => {
            
            if (file.id == document.id) {
              if  (type === 'UniqueSupplier'){
                file.unique_supplier = value;
                if (value === true) {
                  file.has_contract = false;
                  file.unique_supplier_with_contract = false;
                }
              }
              if  (type === 'hasContract'){
                file.has_contract = value;
                file.unique_supplier_with_contract = value;
                if (value === true){
                  file.unique_supplier = false;
                }
              }
            }else {
              if  (type === 'UniqueSupplier'){
                file.unique_supplier = value ? false : file.unique_supplier;
              }
              if  (type === 'hasContract'){
                file.has_contract = value ? false : file.has_contract;
                file.unique_supplier_with_contract = value ? false : file.unique_supplier_with_contract;
              }
            }
      
          });
          
          
          if(value && !document.valid_supplier && this.typeRequestService !== REQUEST_SERVICE_MAVERICK ){
            await this.showSupplierCreationRequestAlert();
          }
        } else {
         
          if (type === 'UniqueSupplier') {
            document.unique_supplier = value;
            if (value === true) {
              document.has_contract = false;
              document.unique_supplier_with_contract = false;
            }
          } else if (type === 'hasContract') {
            document.has_contract = value;
            document.unique_supplier_with_contract = value;
            if (value === true) {
              document.unique_supplier = false;
            }
          }
         
          if(document.quotation_id){
            let payloadToUpdateService = {
              [document.quotation_id]: {
                action: 'update',
                selected: this.currentService.documents.filter(item => item.quotation_id && item.selected).map(item => item.id),
                tax_exempt: this.currentService.documents.filter(item => item.quotation_id && item.tax_exempt).map(item => item.id),
                unique_supplier: (document.unique_supplier && !document.unique_supplier_with_contract && !document.has_contract) ? [document.id] : [],
                has_contract: document.has_contract ? [document.id] : [],
                unique_supplier_with_contract: document.unique_supplier_with_contract ? [document.id] : [],
              },
            };
            await this.updateService({}, payloadToUpdateService, false);
            this.keyDocumentsTable++;
          } else {
            await this.updateService({
              [document.document_name]: {
                action: 'update',
                comment: "Modificación de proveedor unico",
                selected: document.selected,
                supplier: document.supplier,
                type: document.document_type,
                unit_price: document.price,
                coin: document.coin ? document.coin : "CLP",
                unique_supplier: document.unique_supplier,
                unique_supplier_with_contract: document.unique_supplier_with_contract,
                has_contract: document.has_contract,
                tax_exempt: document.tax_exempt
              }
            }, {}, false);
            this.keyDocumentsTable++;
          }
      }
    },

    async changeUniqueSupplierDocument(document, value) {
      if (value) {
        let self = this;
        let message = `
          <p class="text-center"> 
            Al aceptar la selección de Proveedor Único. El usuario toma conocimiento y responsabilidad de los riesgos y consecuencias asociadas a la contratación de este.
            Se considerarán como proveedores únicos aquellos proveedores que cumplan con las siguientes características:
          </p>
          <br />
          <ul class="d-flex flex-column align-items-start">
            <li class="">Condición de mercado monopólica.</li>
            <li>Acuerdos para la terminación de contratos previos.</li>
            <li>Emergencias e imprevistos.</li>
            <li>Convenios preestablecidos.</li>
            <li>Servicios de Naturaleza confidencial.</li>
          </ul>
        `;
        const result = await this.$swal.fire({
          icon: 'warning',
          title: '¡Advertencia!',
          html: message,
          width: '700px',
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
        });
        if (result.isConfirmed) {
          await self.updateUniqueSupplierDocument(document, true);
        } else {
          await self.updateUniqueSupplierDocument(document, false);
        }
      } else {
        await this.updateUniqueSupplierDocument(document, false);
      }
    },

  
    async changeContractStatusDocument(document, value) {
      if (document.has_contract === undefined) {
        document.has_contract = false;
      }
      if (document.unique_supplier_with_contract === undefined) {
        document.unique_supplier_with_contract = false;
      }

      let self = this;
      let message = `
        <p class="text-center"> 
          Al aceptar la selección de Proveedor Único con Contrato. El usuario toma conocimiento y responsabilidad de los riesgos y consecuencias asociadas a la contratación de este.
          Se considerarán como proveedores únicos aquellos proveedores que cumplan con las siguientes características:
        </p>
        <br />
        <ul class="d-flex flex-column align-items-start">
          <li class="">Condición de mercado monopólica.</li>
          <li>Acuerdos para la terminación de contratos previos.</li>
          <li>Emergencias e imprevistos.</li>
          <li>Convenios preestablecidos.</li>
          <li>Servicios de Naturaleza confidencial.</li>
        </ul>
      `;

      if (value) {
        const result = await this.$swal.fire({
          icon: 'warning',
          title: '¡Confirmación de Contrato!',
          html: message,
          width: '700px',
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
        });
        if (result.isConfirmed) {
          await self.updateUniqueSupplierDocument(document, true, 'hasContract');
        } else {
          await self.updateUniqueSupplierDocument(document, false, 'hasContract');
        }
      } else {
        await this.updateUniqueSupplierDocument(document, false, 'hasContract');
      }
    },

    async changeTaxExemptDocument(document) {
      let self = this;
      if(this.userCreateRequestService){
          this.currentService.documents.forEach((file) => {
            if (file.id == document.id) {
              file.tax_exempt = !document.tax_exempt;
            }
          });
          this.keyDocumentsTable++;
        }else {
          if(document.quotation_id){
            let payloadToUpdateService = {
                [document.quotation_id]: {
                  action: 'update',
                  selected: this.currentService.documents.filter(item => item.quotation_id && item.selected).map(item => item.id),
                  unique_supplier: this.currentService.documents.filter(item => item.quotation_id && item.unique_supplier && !item.unique_supplier_with_contract && !item.has_contract).map(item => item.id),
                  tax_exempt: !document.tax_exempt ? [document.id] : []
                },
              }
           return await this.updateService({}, payloadToUpdateService)
          }else {
            await this.updateService({
              [document.document_name]: {
                action: 'update',
                comment: "Modificación de Exento de IVA",
                selected: document.selected,
                supplier: document.supplier,
                type: document.document_type,
                unit_price: document.price,
                coin: document.coin ? document.coin : "CLP",
                unique_supplier: document.unique_supplier,
                tax_exempt: !document.tax_exempt
              }
            });
            this.keyDocumentsTable++;
          }
      }
    },
  
    async selectDocument(document) {
      const newSelected = !document.selected;
      const isOnlyOneQuote = this.documentFilesFromCategory.length === 1;

      
      if (newSelected && !document.valid_supplier && this.typeRequestService !== REQUEST_SERVICE_MAVERICK) {
        if (isOnlyOneQuote) {
          await this.showSupplierCreationRequestAlert();
          document.selected = false;
          this.keyDocumentsTable++;
          return; 
        } else {
          await this.showSupplierCreationRequestAlert();
          
          document.selected = false;
          
          this.keyDocumentsTable++;
          return;
        }
      }

      
      if(this.userCreateRequestService){
        this.currentService.documents.forEach((file) => {
          if (file.id == document.id) {
            file.selected = newSelected;
          }else {
            file.selected = false;
          }
        });
        this.keyDocumentsTable++;
      }else {
        if(document.quotation_id){
          let payloadToUpdateService = {
              [document.quotation_id]: {
                action: 'update',
                selected: newSelected ? [document.id] : [],
                unique_supplier: this.currentService.documents.filter(item => item.quotation_id && item.unique_supplier && !item.unique_supplier_with_contract && !item.has_contract).map(item => item.id),
                has_contract: this.currentService.documents.filter(item => item.quotation_id && item.has_contract).map(item => item.id),
                tax_exempt: this.currentService.documents.filter(item => item.quotation_id && item.tax_exempt).map(item => item.id)
              },
            }
          await self.updateService({}, payloadToUpdateService)
        }else {
          await this.updateService({
            [document.document_name]: {
              action: 'update',
              comment: "Modificación de selección",
              selected: newSelected,
              supplier: document.supplier,
              type: document.document_type,
              unit_price: document.price,
              coin: document.coin ? document.coin : "CLP",
              unique_supplier: document.unique_supplier,
              has_contract: document.has_contract,
              tax_exempt: document.tax_exempt
            }
          });
          this.keyDocumentsTable++;
        }
      }
    },
    // ==================== FIN MÉTODO MODIFICADO ====================

    executeModalFilesService($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        if(this.validationToCloseModalFilesService()){
          this.form.files = [];
          this.closeModalFilesService($event);
        }else {
          this.closeModalFilesService({keyCode: 26});
        }
      }
    },
    validationToCloseModalFilesService(){
      if(
        (this.userCreateRequestService && this.REQUEST_SERVICE_CONSTANTS.ifServiceHasMoreThanOneQuoteAndNoOneIsSelected(
          this.currentService
        )) || (this.requestingUserModule &&  REQUEST_SERVICE_CONSTANTS.getServiceQuotesPostService(this.currentService).length >
        1 && !REQUEST_SERVICE_CONSTANTS.getServiceQuotesPostService(this.currentService).find((document) => document.selected))){
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Debes seleccionar al menos una cotización para poder enviar el servicio",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 7000,
            timerProgressBar: true,
          });
          return false
        }
      if(
          (this.userCreateRequestService && REQUEST_SERVICE_CONSTANTS.getServiceQuotes(this.currentService).length == 1 && !REQUEST_SERVICE_CONSTANTS.getServiceQuotes(this.currentService).find((document) => document.valid_supplier)) ||
          (this.requestingUserModule && REQUEST_SERVICE_CONSTANTS.getServiceQuotesPostService(this.currentService).length == 1 && !REQUEST_SERVICE_CONSTANTS.getServiceQuotesPostService(this.currentService).find((document) => document.valid_supplier))
        ){
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "La cotización debe tener un proveedor válido",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 7000,
            timerProgressBar: true,
          });
          return false
      }
      return true
    },
    formatCurrency(value) {
      if(value) {
        let sanitizedValue = String(value).replace(/[^\d,]/g, '');
        let number = parseFloat(sanitizedValue.replace(/,/g, '.'));

        if (isNaN(number) || sanitizedValue.charAt(sanitizedValue.length - 1) === ',') {
          return value;
        }
        if (isNaN(number) || sanitizedValue.charAt(sanitizedValue.length - 1) === ',') {
          return value;
        }

        return number.toLocaleString('en-US', { maximumFractionDigits: 2 }).replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, ',');
      } else {
       return value;
      }
    },
    formatPrice(document, event) {
      if (document.coin === REQUEST_SERVICE_CONSTANTS.coin_types[0].value && (event.target.value.includes(','))) {
        document.price = event.target.value.replaceAll(/,/g, '');
      }
      document.price = this.formatCurrency(document.price);
    },
    formatCurrentDocumentPrice(document, event) {
      if (document.coin === REQUEST_SERVICE_CONSTANTS.coin_types[0].value && (event.target.value.includes(','))) {
        this.currentDocumentPrice = event.target.value.replaceAll(/,/g, '');
      }
      this.currentDocumentPrice = this.formatCurrency(this.currentDocumentPrice);
    },
    updateFiles(newFiles) {
      if (
        newFiles.length &&
        newFiles.find((file) => file.type !== "application/pdf")
      ) {
        this.form.files = [];
        return swal2.fire({
          icon: "error",
          title: "Error",
          text: "Solo se permiten archivos de formato PDF",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 5000,
          timerProgressBar: true,
        });
      }
      if (newFiles.length && newFiles !== this.form.files) {
        this.form.files = [...this.form.files, ...newFiles];
      }
    },
    updateFilesService() {
      if (this.form.files !== this.currentService.documents) {
        let fileNameDuplicated = false;
        this.form.files.forEach((file) => {
          if (
            this.currentService.documents.filter(document => !document.quotation_id).find(
              (document) => document.file.name === file.name
            )
          ) {
            fileNameDuplicated = true;
          }
        });
        if (fileNameDuplicated) {
          return swal2.fire({
            icon: "error",
            title: "Error",
            text: "Ya existe un archivo con el mismo nombre",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
        this.currentService.documents = [
          ...this.currentService.documents,
          ...this.form.files.map((item, index) => ({
            file: item,
            id: new Date().getTime() + index,
            single_supplier_letter: false,
            category: this.tabsFiles,
            unique_supplier: false,
            unique_supplier_with_contract: false,
            has_contract: false,
            tax_exempt: false,
            selected: false,
            coin: "CLP",
          })),
        ];
        if(this.currentService.documents.length == 1){
          this.currentService.documents[0].selected = true
        }else {
          this.currentService.documents.filter(document => !document.quotation_id).map(document => {
            document.selected = false
          })
        }
      }
      this.form.files = [];
    },
    async updateFilesUploadService(userUpload = null) {
      let self = this;
      if(!userUpload){
        self.loading = true;
      }
      let filesToUpload = [];
      let payload = {
        service_id: self.currentService ? self.currentService.id : undefined,
        user: userUpload ? userUpload : self.user.email,
        unit_price: self.currentService.unit_price,
        quantity: self.currentService.quantity,
        quotations: {},
        documents: self.form.files.reduce((acc, cur, index) => {
          let uniqueCode = generateRandomCode();
          let filename =  !userUpload ? `${
            self.currentService.sap_code
          }_${uniqueCode}_${cur.name}` : `${cur.name}`;
          let fileWithNewName = renameAndReturnNewFile(cur, filename);
          acc[filename] = {
            action: 'add',
            comment: "Archivo cargado",
            selected: !REQUEST_SERVICE_CONSTANTS.getServiceQuotesPostService(self.currentService).length && self.form.files.length == 1 ? true : false,
            supplier: null,
            type: REQUEST_SERVICE_CONSTANTS.getTypeDocumentFromFile(
              cur.category ? cur.category : {category: self.tabsFiles},
              (self.typeRequestService == REQUEST_SERVICE_MAVERICK || self.typeRequestService == REQUEST_SERVICE_UNIQUE_SUPPLIER)
            ),
            unit_price: 0,
            unique_supplier: false,
            has_contract: false,
            tax_exempt: false,
            coin: 'CLP',
          };
          filesToUpload.push(fileWithNewName);
          return acc;
        }, {}),
      };
      payload.files = filesToUpload;
      const resp = await self.sendUpdateFilesService(payload);
      if (resp?.status == 200) {
        if(!userUpload){
          swal2.fire({
            icon: "success",
            title: "Excelente",
            text: "Documentos agregados correctamente",
            position: "top-end",
            showConfirmButton: false,
            toast: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
        self.form.files = [];
        self.$emit("filesUploaded", self.currentService);
        self.loading = false;
        return resp.data
    }
    if (!resp?.status || resp?.status === 400) {
        self.loading = false;
        return swal2.fire({
          icon: "error",
          title: "Error",
          text: resp
            ? resp.data.detail
            : "Ha ocurrido un error de servidor, intentalo nuevamente",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 10000,
          timerProgressBar: true,
        });
    }
    self.loading = false;
  },
  async updatePriceQuotation(document) {
    let self = this;
    if (!self.currentDocumentPrice || 
        self.currentDocumentPrice.replaceAll('.', '').replaceAll(",", ".") == 0 || 
        isNaN(Number(this.currentDocumentPrice.replaceAll(".", "").replaceAll(",", ".")))
      ) {
      return self.$swal.fire({
        icon: "error",
        title: "Error",
        text: "El precio debe ser mayor que 0",
        position: "top-end",
        showConfirmButton: false,
        toast: true,
        timer: 5000,
        timerProgressBar: true,
      });    
    }
    this.$swal
      .fire({
        icon: "info",
        title: `Confirma el precio para la cotización: <b>${
          document.document_name ? document.document_name : "-"
        }</b> de $${this.currentDocumentPrice}?`,
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonColor: "#1076D0",
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          this.loadingDocument = true;
          const payload = {
            [document.document_name]: {
              action: 'update',
              comment: "Modificación de precio",
              selected: document.selected,
              supplier: document.supplier,
              type: document.document_type,
              unit_price: Number(self.currentDocumentPrice.replaceAll(".", "").replaceAll(",", ".")),
              coin: document.coin ? document.coin : "CLP",
              unique_supplier: document.unique_supplier,
              has_contract: document.has_contract,
              tax_exempt: document.tax_exempt
            }
          }
          let currentDocumentPrice = Number(self.currentDocumentPrice.replaceAll(".", "").replaceAll(",", "."))
          await this.updateService(payload);
          if(currentDocumentPrice){
            this.sendUpdateExchangeRates({...document, price: currentDocumentPrice}, false)
          }
        }
      });
  },
  setCurrentDocumentEdit(document) {
      this.currentDocumentEdit = document.id;
      this.currentDocumentPrice = document.price ? document.price.toLocaleString('en-US', { maximumFractionDigits: 2 }).replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, ',') : 0;
  },

  
  async updateService(documents, quotations = {}, emitUpdate = true){
    this.loading = true;
    let payload = {
      service_id: this.currentService.id,
      quantity: this.currentService.quantity,
      documents: documents,
      user: this.user.email,
      quotations,
    };
    const resp = await this.sendUpdateService(payload);
    if (!resp || !resp.status || resp.status == 500) {
      this.$swal({
        icon: "error",
        title: "Error",
        text: "Ha ocurrido un error en el servidor, intenta nuevamente",
        position: "top-end",
        showConfirmButton: false,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
      });
      this.loadingDocument = false;
      return this.loading = false;
    }
    if (resp.status == 400) {
      this.$swal({
        icon: "error",
        title: "Error",
        text: resp.data.detail,
        position: "top-end",
        showConfirmButton: false,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
      });
      this.loadingDocument = false;
      return this.loading = false;
    }
    if (resp.status == 200) {
     
      this.$swal({
        icon: "success",
        title: "Excelente",
        text: `Cotización actualizada correctamente`,
        position: "top-end",
        showConfirmButton: false,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
      });
      this.currentDocumentEdit = null;
      this.currentDocumentPrice = null;
     
      if (emitUpdate) {
        this.$emit("updateDocumentsCurrentService");
      }
    } else {
      console.log('[updateService] response non-200', { status: resp.status, resp });
    }
    this.loading = false;
  },
  async deleteFile({ id, file }) {
      swal2
        .fire({
          icon: "info",
          title: `¿Estás seguro de eliminar este archivo: ${file.name}`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "red",
          confirmButtonText: "Eliminar",
          cancelButtonText: `Cancelar`,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.currentService.documents = this.currentService.documents.filter(
              (document) => document.id !== id
            );
          }
        });
    },
    async deleteUploadFile(file) {
      swal2
        .fire({
          icon: "info",
          title: `¿Estás seguro de eliminar este documento: ${file.document_name}`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "red",
          confirmButtonText: "Eliminar",
          cancelButtonText: `Cancelar`,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.loading = true;
            let payload = {
              request_id: this.requestId,
              document_id: file.id,
              user: this.user.email,
              service_id: this.currentService.id,
            };
            const resp = await this.sendDeleteFile(payload);
            if (!resp || !resp.status || resp.status == 500) {
              swal2.fire({
                icon: "error",
                title: "Error",
                text: "Ha ocurrido un error en el servidor, intenta nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp && resp.status == 200) {
              swal2.fire({
                icon: "success",
                title: "Excelente",
                text: `Archivo del servicio eliminado correctamente`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
              this.$emit("updateDocumentsCurrentService");
            }
            this.loading = false;
          }
        });
    },
    async addSupplierSelected(payload) {
      let self = this
      if(this.onlyRut){
        this.onlyRut = false;
      }
      if(this.userCreateRequestService){

        this.currentService.documents.forEach((file) => {
          if (file.id == self.currentDocument.id) {
            file.supplier_name = payload.name ? payload.name : null;
            file.supplier_rut = payload.rut;
            file.valid_supplier = 'valid_supplier' in payload ? payload.valid_supplier : true
          }
        });

        this.keyDocumentsTable++;
      }else {
        this.loadingDocument = true;
        await this.updateService({
            [this.currentDocument.document_name]: {
              action: 'update',
              comment: "Modificación de proveedor",
              selected: this.currentDocument.selected,
              supplier: payload.rut,
              type: this.currentDocument.document_type,
              unit_price: this.currentDocument.price ?
                 this.currentDocument.price : this.currentDocument.unit_price 
                 ? this.currentDocument.unit_price : 0,
              coin: this.currentDocument.coin ? this.currentDocument.coin : "CLP",
              unique_supplier: this.isUpdatingUniqueSupplier ? true : this.currentDocument.unique_supplier,
              has_contract: this.currentDocument.has_contract
            }
          });
          this.isUpdatingUniqueSupplier = false
      }
      this.keyDocumentsTable++;
    },
    openModalAddSupplier({search, filterFrom}) {
      if(filterFrom == "rut"){
        this.$refs.tableAddSupplier.filters.rut = search;
        this.$refs.tableAddSupplier.showFilterName = false;
      }else{
        this.$refs.tableAddSupplier.filters.name = search;
        this.$refs.tableAddSupplier.showFilterRut = false;
      }
      this.$refs.tableAddSupplier.getSuppliers(
        1,
        (this.typeRequestService == REQUEST_SERVICE_MAVERICK || this.typeRequestService == REQUEST_SERVICE_UNIQUE_SUPPLIER) ? true : false
      );
      this.dialogAddSupplier = true;
    },
    closeModalTableAddSupplier() {
      this.dialogAddSupplier = false;
    },
    openModalSearchSupplier(document) {
      this.currentDocument = null;
      this.currentDocument = document;
      this.dialogSearchSupplier = true;
    },
    closeModalSearchSupplier() {
      this.dialogSearchSupplier = false;
    },
    openModalCreateSupplierAndSetDocument(document, isUpdatingUniqueSupplier){
      this.currentDocument = null;
      this.currentDocument = document;
      this.isUpdatingUniqueSupplier = isUpdatingUniqueSupplier;
      this.showSupplierCreationRequestAlert();
    },  
    openModalCreateSupplier(){
      this.showSupplierCreationRequestAlert();
    },
    closeModalCreateSupplier() {
      this.dialogCreateSupplier = false;
    },
    openModalSetOnlyRutSupplier(rut){
      if(rut){
        return this.addSupplierSelected({name: rut, rut: rut, valid_supplier: false});
      }
      this.onlyRut = true;
      this.$refs.searchSupplier.rut = rut;
      this.dialogSearchSupplier = true;
    },
    openModalTableAddQuote(){
      this.dialogTableAddQuotes = true;
    },
    closeModalTableAddQuote(){
      this.dialogTableAddQuotes = false;
    },
    permissionToDeleteFile(document) {
      if(this.userCreateRequestService){
        return true
      }
      if(document.created_by == this.user.email){
        return true
      }
      if(document.created_by != this.currentRequest.created_by && this.currentRequest.created_by != this.user.email){
        return true
      }
      return false
    },
    async onAddQuoteSelectedToService(payload) {
      let self = this
      if(this.userCreateRequestService){
        this.currentService.quotation_attached = {
          id: payload.id,
          shopping_index: payload.shopping_index,
        } 
        let mappedDocumentsWithExchangeRate = await this.mapExchangeRate(payload.documents);
        this.currentService.documents = this.currentService.documents.filter(document => !document.quotation_id)
        this.currentService.documents = [
          ...this.currentService.documents.map(item => ({...item, selected : false})),
          ...mappedDocumentsWithExchangeRate.map((item) => ({
              ...item,
              category: REQUEST_SERVICE_CONSTANTS.getDocumentCategory(item.document_type, false),
              price: self.formatCurrency(item.price),
              quotation_id: payload.id,
              supplier_rut: item.supplier,
              selected: false,
              unique_supplier: false,
              has_contract: false,
          }))
        ]
      }else {
        let payloadToUpdateService = {
              [payload.id]: {
                action: 'add',
                selected: [],
                unique_supplier: [],
                has_contract: [],
                tax_exempt: []
              },
              [self.currentService.quotation_attached ? self.currentService.quotation_attached.id : '-' ]: self.currentService.quotation_attached ? {
                action: 'delete',
                selected: false,
                unique_supplier: false,
                has_contract: false,
                tax_exempt: false
              }: undefined
            }
        await self.updateService({}, payloadToUpdateService)
      }
      this.keyDocumentsTable++;
    },
    dettachQuotationToService(){
      let self = this;
      this.$swal.fire({
        title: `¿Está seguro de desvincular la cotización: ${this.currentService.quotation_attached.shopping_index}?`,
        text: 'Esta acción no se puede deshacer',
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      }).then(async(result) => {
        if (result.value) {
          if(self.userCreateRequestService){
            self.currentService.quotation_attached = null
            self.currentService.documents = self.currentService.documents.filter(item => !item.quotation_id)
            self.keyDocumentsTable++;
          }else {
            let payload = {
              [self.currentService.quotation_attached.id]: {
                action: 'delete',
                selected: false,
                unique_supplier: false,
                has_contract: false,
                tax_exempt: false
              } 
            }
            await self.updateService({}, payload)
          }
        }
      })
    },
    async generateOcPDF(previewOc = false){
     if(REQUEST_SERVICE_CONSTANTS.ifServiceHasOC(this.currentService)){
      return
     }
     this.loadingGeneratingOc = true
     const respOc = await this.getDataOcFromSoc({
        purchase_order: this.currentRequest.sale_order
      })
     if(!respOc.purchase_order || !respOc.purchase_order.length){
       this.loadingGeneratingOc = false
       return
     }
     let purchaseOrderCurrentService = respOc.purchase_order.find(item => item['Materiales'].some(
       material => material.Codigo == this.currentService.sap_code
     ));
     
     if(!purchaseOrderCurrentService){
       this.loadingGeneratingOc = false
       return this.$swal.fire({
        icon: "error",
        title: "Error",
        text: "Ha ocurrido un error en el servidor, intenta nuevamente",
        position: "top-end",
        showConfirmButton: false,
        toast: true,
        timer: 4000,
        timerProgressBar: true,
      });
     }
     const filePdfOc = REQUEST_SERVICE_CONSTANTS.generateOcPDF(
      {
        ...purchaseOrderCurrentService,
        purchase_user: this.currentRequest.assigned_users[0].user.full_name,
        sale_order: this.currentRequest.sale_order,

      },
      `${purchaseOrderCurrentService['Numero'].toString()} - ${this.currentRequest.sale_order}`
     )
     this.form.files.push(filePdfOc)
     const responseService = await this.updateFilesUploadService(
      this.currentRequest.assigned_users[0].user.email
     )
     if(previewOc){
      let ocGenerated = REQUEST_SERVICE_CONSTANTS.ifServiceHasOC(responseService)
      this.loadingGeneratingOc = false
      return this.downloadFile(ocGenerated, previewOc)
     }
     this.loadingGeneratingOc = false
    
    }

  },
  computed: {
    ...authUsuarioComputed,
    currentServiceStatusIsPendingUser() {
      return (
        this.currentService &&
        this.currentService.status ===
          REQUEST_SERVICE_CONSTANTS.service_statuses.pending_user
      );
    },
    currentServiceStatusIsQuotation() {
      return (
        this.currentService &&
        this.currentService.status ===
          REQUEST_SERVICE_CONSTANTS.service_statuses.in_quotation
      );
    },
    currentServiceStatusIsQuotationOrInReview() {
      return (
        this.currentService &&
        (this.currentServiceStatusIsQuotation ||
          this.currentService.status ===
            REQUEST_SERVICE_CONSTANTS.service_statuses.in_review)
      );
    },
    currentServiceStatusIsQuotationInValidation(){
      return (
        this.currentService &&
          this.currentService.status ===
            REQUEST_SERVICE_CONSTANTS.service_statuses.quotation_in_validation
      );
    },
    currentRequestStatusIsPendingValidation(){
      return (
        this.currentRequest &&
          this.currentRequest.status ===
            REQUEST_SERVICE_CONSTANTS.service_statuses.pending_validation
      );
    },
    currentRequestStatusIsUserValidationVariant(){
      return (
        this.currentRequest &&
          this.currentRequest.status ===
            REQUEST_SERVICE_CONSTANTS.service_statuses.user_validation_variant
      );
    },
    currentRequestStatusIsPurchaseValidationVariant(){
      return (
        this.currentRequest &&
          this.currentRequest.status ===
            REQUEST_SERVICE_CONSTANTS.service_statuses.purchase_validation_variant
      );
    },
    currentRequestStatusIsRejected(){
      return (
        this.currentRequest &&
          (this.currentRequest.status ===
            REQUEST_SERVICE_CONSTANTS.service_statuses.rejected || this.currentRequest.status === REQUEST_SERVICE_CONSTANTS.service_statuses.rejected_variant)
      );
    },
    currentRequestStatusIsPurchaseValidation(){
      return (
        this.currentRequest &&
          this.currentRequest.status ===
            REQUEST_SERVICE_CONSTANTS.service_statuses.purchase_validation
      );
    },
    currentRequestStatusIsPendingApproval(){
      return (
        this.currentRequest &&
          this.currentRequest.status ===
            REQUEST_SERVICE_CONSTANTS.service_statuses.pending
      );
    },
    currentRequestIsApproved(){
      return (
        this.currentRequest &&
        this.currentRequest.approval_request &&
        this.currentRequest.approval_request.sent_to_erp
      );
    },
    currentRequestIsApprovedOc(){
      return (
        this.currentRequest &&
        this.currentRequest.approval_request &&
        this.currentRequest.approval_request.sale_order_created
      );
    },
    activeManagmetFiles() {
       if (((this.typeRequestService != REQUEST_SERVICE_MAVERICK && this.typeRequestService != REQUEST_SERVICE_UNIQUE_SUPPLIER) &&
        (this.currentRequest && this.currentRequest.status === REQUEST_SERVICE_CONSTANTS.service_statuses.user_validation_variant) &&
        this.currentServiceStatusIsPendingUser && this.requestingUserModule)) {
        return true
      } 
      if (((this.typeRequestService == REQUEST_SERVICE_MAVERICK || this.typeRequestService == REQUEST_SERVICE_UNIQUE_SUPPLIER) &&
        (this.currentRequest && this.currentRequest.status === REQUEST_SERVICE_CONSTANTS.service_statuses.user_validation) &&
        this.currentServiceStatusIsQuotationInValidation && this.requestingUserModule)) {
        return true
      } 
      if(
        (this.typeRequestService != REQUEST_SERVICE_MAVERICK && this.typeRequestService != REQUEST_SERVICE_UNIQUE_SUPPLIER) &&
        this.currentServiceStatusIsQuotationOrInReview &&
        !this.requestingUserModule
      ){
        return true
      }
      if(
      (this.typeRequestService != REQUEST_SERVICE_MAVERICK && this.typeRequestService != REQUEST_SERVICE_UNIQUE_SUPPLIER) &&
      (this.currentRequestStatusIsPurchaseValidation)&&
      !this.requestingUserModule
      ){
        return true
      }

      return false
    },
    activeEditPriceAndSupplierFiles() {
       if (((this.typeRequestService != REQUEST_SERVICE_MAVERICK && this.typeRequestService != REQUEST_SERVICE_UNIQUE_SUPPLIER) &&
        (this.currentRequest && this.currentRequest.status === REQUEST_SERVICE_CONSTANTS.service_statuses.user_validation_variant) &&
        this.currentServiceStatusIsPendingUser && this.requestingUserModule)) {
        return true
      } 
      if (((this.typeRequestService == REQUEST_SERVICE_MAVERICK || this.typeRequestService == REQUEST_SERVICE_UNIQUE_SUPPLIER) &&
        (this.currentRequest && this.currentRequest.status === REQUEST_SERVICE_CONSTANTS.service_statuses.user_validation) &&
        this.currentServiceStatusIsQuotationInValidation && this.requestingUserModule)) {
        return true
      } 
      if (
        (this.typeRequestService != REQUEST_SERVICE_MAVERICK && this.typeRequestService != REQUEST_SERVICE_UNIQUE_SUPPLIER) &&
        ((this.currentServiceStatusIsQuotationOrInReview && !this.requestingUserModule) || (this.currentServiceStatusIsQuotation && this.requestingUserModule))
      ) {
        return true
      }
      if(
        (this.typeRequestService != REQUEST_SERVICE_MAVERICK && this.typeRequestService != REQUEST_SERVICE_UNIQUE_SUPPLIER) &&
        this.currentRequestStatusIsPurchaseValidation &&
        !this.requestingUserModule
      ){
        return true
      }

      return false
    },
    permissionToUserChangeSelected(){
      return (this.requestingUserModule &&
        (this.currentRequestStatusIsUserValidationVariant || this.currentRequestStatusIsPurchaseValidationVariant)) 
       || this.currentRequestStatusIsPendingApproval
       || this.currentRequestStatusIsPurchaseValidation
      
    },
    documentFilesFromCategory() {
      if (this.currentService) {
        if(this.userCreateRequestService){
          return this.currentService.documents.filter(
            (item) => item.category === this.tabsFiles
          );
        }else {
          return this.currentService.documents
          .map((document) => {
            document.category = REQUEST_SERVICE_CONSTANTS.getDocumentCategory(document.document_type, (this.typeRequestService == REQUEST_SERVICE_MAVERICK || this.typeRequestService == REQUEST_SERVICE_UNIQUE_SUPPLIER));
            return document;
          })
          .filter((document) => document.category == this.tabsFiles)
          .sort((a, b) => a.document_name.localeCompare(b.document_name));
        }
      }
      return [];
    },
    filesRequired() {
      if(this.requestPurchaseOrder && this.currentService){
        if(REQUEST_SERVICE_CONSTANTS.getNumberOfQuotesNeccesarysOCCreated(this.currentService) > 1){
          return [
            {
              name: "3 Cotizaciones",
              count: this.currentService.documents.filter((document) => document.document_type == REQUEST_SERVICE_CONSTANTS.document_category_quotes_text).length,
              status: this.currentService.documents.filter((document) => document.document_type == REQUEST_SERVICE_CONSTANTS.document_category_quotes_text).length >= 3  
            },
          ]          
        }
        return [
          {
            name: "1 Cotización",
            count: this.currentService.documents.filter((document) => document.document_type == REQUEST_SERVICE_CONSTANTS.document_category_quotes_text).length,
            status: this.currentService.documents.find((document) => document.document_type == REQUEST_SERVICE_CONSTANTS.document_category_quotes_text)
          },
        ]
      }
      if(this.currentService){
        return [
          {
            name: "1 Cotización",
            count: this.currentService.documents.filter((document) => document.document_type == REQUEST_SERVICE_CONSTANTS.document_category_quotes_text).length,
            status: this.currentService.documents.find((document) => document.document_type == REQUEST_SERVICE_CONSTANTS.document_category_quotes_text)
          }
        ]
      }
      return []
    },
    actionToUploadFiles() {
      return (
        (this.userCreateRequestService || this.activeManagmetFiles) || 
        (!this.requestingUserModule && this.currentRequestIsApproved && (this.tabsFiles == REQUEST_SERVICE_CONSTANTS.document_category_oc)) ||
        this.uploadFiles &&
        ((!this.requestingUserModule &&
        this.currentServiceStatusIsQuotationOrInReview) ||
        (this.requestingUserModule && this.currentServiceStatusIsQuotation))
      )
    },
  },
};
</script>

<style>
.form-control-quantity {
  border: none;
  border-bottom: 1px solid gray;
  border-radius: 0;
  max-width: 120px;
}
</style>